import { ILineDrawable, instanceOfILineDrawable } from "../../../../base/domain/drawing";
import { IPrintBehaviorSpecifiable, instanceOfIPrintBehaviorSpecifiable } from "../../../../documaker/domain/format/objects";
import { IRectangleCoordinatableObject, instanceOfIRectangleCoordinatableObject } from "./IRectangleCoordinatableObject";
import { ElementTypes } from "./ElementTypes";

// DocuMakerフォーマット仕様(というよりv1フォーマット編集実装仕様)的には図形に背景色なし.(bg属性は出力されない.textureはcolor属性で描画.)
export interface IShapeDrawableObject extends IRectangleCoordinatableObject, IPrintBehaviorSpecifiable, ILineDrawable {}

export function instanceOfIShapeDrawableObject<T extends IShapeDrawableObject>(instance: any, type: ElementTypes): instance is IShapeDrawableObject {
  return instance
      && instanceOfILineDrawable(instance)
      && instanceOfIPrintBehaviorSpecifiable(instance)
      && instanceOfIRectangleCoordinatableObject<T>(instance, type);
}
